function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontTransparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22px",
    height: "22px",
    style: {
      height: 22,
      marginTop: "-4px",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dadb",
    d: "M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 4.5,1.16667 4.5,2.83333 4.5,4.5C 2.83333,4.5 1.16667,4.5 -0.5,4.5C -0.5,2.83333 -0.5,1.16667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 4.5,-0.5 C 6.16667,-0.5 7.83333,-0.5 9.5,-0.5C 9.5,1.16667 9.5,2.83333 9.5,4.5C 7.83333,4.5 6.16667,4.5 4.5,4.5C 4.5,2.83333 4.5,1.16667 4.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808388",
    d: "M 9.5,-0.5 C 11.1667,-0.5 12.8333,-0.5 14.5,-0.5C 14.5,1.16667 14.5,2.83333 14.5,4.5C 12.8333,4.5 11.1667,4.5 9.5,4.5C 9.5,2.83333 9.5,1.16667 9.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 14.5,-0.5 C 16.1667,-0.5 17.8333,-0.5 19.5,-0.5C 19.5,1.16667 19.5,2.83333 19.5,4.5C 17.8333,4.5 16.1667,4.5 14.5,4.5C 14.5,2.83333 14.5,1.16667 14.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M -0.5,4.5 C 1.16667,4.5 2.83333,4.5 4.5,4.5C 4.5,6.16667 4.5,7.83333 4.5,9.5C 2.83333,9.5 1.16667,9.5 -0.5,9.5C -0.5,7.83333 -0.5,6.16667 -0.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb0b4",
    d: "M 4.5,4.5 C 6.16667,4.5 7.83333,4.5 9.5,4.5C 9.5,6.16667 9.5,7.83333 9.5,9.5C 7.83333,9.5 6.16667,9.5 4.5,9.5C 4.5,7.83333 4.5,6.16667 4.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 9.5,4.5 C 11.1667,4.5 12.8333,4.5 14.5,4.5C 14.5,6.16667 14.5,7.83333 14.5,9.5C 12.8333,9.5 11.1667,9.5 9.5,9.5C 9.5,7.83333 9.5,6.16667 9.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#54585e",
    d: "M 14.5,4.5 C 16.1667,4.5 17.8333,4.5 19.5,4.5C 19.5,6.16667 19.5,7.83333 19.5,9.5C 17.8333,9.5 16.1667,9.5 14.5,9.5C 14.5,7.83333 14.5,6.16667 14.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d3239",
    d: "M 19.5,-0.5 C 21.1667,-0.5 22.8333,-0.5 24.5,-0.5C 24.5,4.5 24.5,9.5 24.5,14.5C 22.8333,14.5 21.1667,14.5 19.5,14.5C 19.5,12.8333 19.5,11.1667 19.5,9.5C 19.5,7.83333 19.5,6.16667 19.5,4.5C 19.5,2.83333 19.5,1.16667 19.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 4.5,9.5 C 6.16667,9.5 7.83333,9.5 9.5,9.5C 9.5,11.1667 9.5,12.8333 9.5,14.5C 7.83333,14.5 6.16667,14.5 4.5,14.5C 4.5,12.8333 4.5,11.1667 4.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808388",
    d: "M 9.5,9.5 C 11.1667,9.5 12.8333,9.5 14.5,9.5C 14.5,11.1667 14.5,12.8333 14.5,14.5C 12.8333,14.5 11.1667,14.5 9.5,14.5C 9.5,12.8333 9.5,11.1667 9.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 14.5,9.5 C 16.1667,9.5 17.8333,9.5 19.5,9.5C 19.5,11.1667 19.5,12.8333 19.5,14.5C 17.8333,14.5 16.1667,14.5 14.5,14.5C 14.5,12.8333 14.5,11.1667 14.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dadb",
    d: "M -0.5,9.5 C 1.16667,9.5 2.83333,9.5 4.5,9.5C 4.5,11.1667 4.5,12.8333 4.5,14.5C 2.83333,14.5 1.16667,14.5 -0.5,14.5C -0.5,12.8333 -0.5,11.1667 -0.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M -0.5,14.5 C 1.16667,14.5 2.83333,14.5 4.5,14.5C 4.5,16.1667 4.5,17.8333 4.5,19.5C 2.83333,19.5 1.16667,19.5 -0.5,19.5C -0.5,17.8333 -0.5,16.1667 -0.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb0b4",
    d: "M 4.5,14.5 C 6.16667,14.5 7.83333,14.5 9.5,14.5C 9.5,16.1667 9.5,17.8333 9.5,19.5C 7.83333,19.5 6.16667,19.5 4.5,19.5C 4.5,17.8333 4.5,16.1667 4.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 9.5,14.5 C 11.1667,14.5 12.8333,14.5 14.5,14.5C 14.5,16.1667 14.5,17.8333 14.5,19.5C 12.8333,19.5 11.1667,19.5 9.5,19.5C 9.5,17.8333 9.5,16.1667 9.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#54585e",
    d: "M 14.5,14.5 C 16.1667,14.5 17.8333,14.5 19.5,14.5C 19.5,16.1667 19.5,17.8333 19.5,19.5C 17.8333,19.5 16.1667,19.5 14.5,19.5C 14.5,17.8333 14.5,16.1667 14.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262b33",
    d: "M 19.5,14.5 C 21.1667,14.5 22.8333,14.5 24.5,14.5C 24.5,17.8333 24.5,21.1667 24.5,24.5C 23.8333,24.5 23.1667,24.5 22.5,24.5C 22.5,22.8333 22.5,21.1667 22.5,19.5C 21.5,19.5 20.5,19.5 19.5,19.5C 19.5,17.8333 19.5,16.1667 19.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dadc",
    d: "M -0.5,19.5 C 1.16667,19.5 2.83333,19.5 4.5,19.5C 4.5,21.1667 4.5,22.8333 4.5,24.5C 2.83333,24.5 1.16667,24.5 -0.5,24.5C -0.5,22.8333 -0.5,21.1667 -0.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 4.5,19.5 C 6.16667,19.5 7.83333,19.5 9.5,19.5C 9.5,21.1667 9.5,22.8333 9.5,24.5C 7.83333,24.5 6.16667,24.5 4.5,24.5C 4.5,22.8333 4.5,21.1667 4.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808388",
    d: "M 9.5,19.5 C 11.1667,19.5 12.8333,19.5 14.5,19.5C 14.5,21.1667 14.5,22.8333 14.5,24.5C 12.8333,24.5 11.1667,24.5 9.5,24.5C 9.5,22.8333 9.5,21.1667 9.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a31",
    d: "M 14.5,19.5 C 16.1667,19.5 17.8333,19.5 19.5,19.5C 19.5,21.1667 19.5,22.8333 19.5,24.5C 17.8333,24.5 16.1667,24.5 14.5,24.5C 14.5,22.8333 14.5,21.1667 14.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#393e45",
    d: "M 19.5,19.5 C 20.5,19.5 21.5,19.5 22.5,19.5C 22.5,21.1667 22.5,22.8333 22.5,24.5C 21.5,24.5 20.5,24.5 19.5,24.5C 19.5,22.8333 19.5,21.1667 19.5,19.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontTransparency);
export default __webpack_public_path__ + "static/media/font_transparency.f96ffe51.svg";
export { ForwardRef as ReactComponent };